import { useState } from 'react';
import type { PageDefinition } from '@obraplan/core/domain/access/pages';

/**
 * As telas, em uma linha: as primeiras pelo nome e o resto num "+N" que abre a lista.
 *
 * Numa tabela de perfis, dezenove nomes por linha empurrariam as ações para fora da tela;
 * só o número não diria nada. Os primeiros nomes bastam para reconhecer o papel, e o
 * resto está a um clique.
 */
export function PageSummary({
  pages,
  shown = 4,
}: {
  pages: readonly PageDefinition[];
  shown?: number;
}) {
  const [expanded, setExpanded] = useState(false);

  if (pages.length === 0) {
    return <span className="text-sm text-(--color-content-muted)">Nenhuma tela</span>;
  }

  const visible = expanded ? pages : pages.slice(0, shown);
  const rest = pages.length - visible.length;

  return (
    <span className="text-sm">
      <span className="font-medium tabular">{pages.length}</span>
      <span className="text-(--color-content-muted)"> · </span>
      {visible.map((page) => page.label).join(', ')}
      {rest > 0 && (
        <>
          {' '}
          <button
            type="button"
            className="text-(--color-brand) underline-offset-4 hover:underline"
            aria-expanded={false}
            onClick={() => setExpanded(true)}
          >
            +{rest}
          </button>
        </>
      )}
    </span>
  );
}
